module.exports = "/packs/images/pages/zendesk/zendeskhero~679b3c4b9529693c4c1e0815354dc702.jpg";